import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Tabs, Tab, Box } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import PendingPayments from "./components/PendingPayments";
import PaymentHistory from "./components/PaymentHistory";
import FinancialReports from "./components/FinancialReports";
import { useTitle } from "../../hooks/useTitle";

const useStyles = makeStyles((theme) => ({
	mainPaper: {
		flex: 1,
		padding: theme.spacing(1),
		overflowY: "auto",
		...theme.scrollbarStyles,
		backgroundColor: theme.palette.background.default,
	},
	tabs: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: 8,
		marginBottom: theme.spacing(2),
		boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
	}
}));

const TabPanel = ({ children, value, index }) => {
	return value === index ? <Box py={2}>{children}</Box> : null;
};

const Billing = () => {
	useTitle("Caja y Cobranzas");
	const classes = useStyles();
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	return (
		<MainContainer>
			<Paper className={classes.tabs} square={false}>
				<Tabs
					value={activeTab}
					onChange={handleTabChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
				>
					<Tab label="Pendientes de Cobro" />
					<Tab label="Historial de Cobros" />
					<Tab label="Reportes Financieros" />
				</Tabs>
			</Paper>

			<div className={classes.mainPaper}>
				<TabPanel value={activeTab} index={0}>
					<PendingPayments />
				</TabPanel>

				<TabPanel value={activeTab} index={1}>
					<PaymentHistory />
				</TabPanel>

				<TabPanel value={activeTab} index={2}>
					<FinancialReports />
				</TabPanel>
			</div>
		</MainContainer>
	);
};

export default Billing;